module.exports = __webpack_public_path__ + "static/bg-wedding-fec9d4805c581185e5da8dbbd2451d91.jpeg";